import { lazy } from "react";
export const lazyIcons = {
    IconAccessibility: lazy(() => import('./IconAccessibility.js')),
    IconActiveIngredients: lazy(() => import('./IconActiveIngredients.js')),
    IconAi: lazy(() => import('./IconAi.js')),
    IconAiChatbot: lazy(() => import('./IconAiChatbot.js')),
    IconApp: lazy(() => import('./IconApp.js')),
    IconApple: lazy(() => import('./IconApple.js')),
    IconArrowLeft: lazy(() => import('./IconArrowLeft.js')),
    IconArrowRight: lazy(() => import('./IconArrowRight.js')),
    IconAssortment: lazy(() => import('./IconAssortment.js')),
    IconBaby: lazy(() => import('./IconBaby.js')),
    IconBacteria: lazy(() => import('./IconBacteria.js')),
    IconBarcode: lazy(() => import('./IconBarcode.js')),
    IconBeaker: lazy(() => import('./IconBeaker.js')),
    IconBio: lazy(() => import('./IconBio.js')),
    IconBladder: lazy(() => import('./IconBladder.js')),
    IconBlister: lazy(() => import('./IconBlister.js')),
    IconBloodPressureHigh: lazy(() => import('./IconBloodPressureHigh.js')),
    IconBookmarkHeart: lazy(() => import('./IconBookmarkHeart.js')),
    IconBookmarkHeartActive: lazy(() => import('./IconBookmarkHeartActive.js')),
    IconBug: lazy(() => import('./IconBug.js')),
    IconCalendar: lazy(() => import('./IconCalendar.js')),
    IconCamera: lazy(() => import('./IconCamera.js')),
    IconCancelOrder: lazy(() => import('./IconCancelOrder.js')),
    IconCaretDown: lazy(() => import('./IconCaretDown.js')),
    IconCaretLeft: lazy(() => import('./IconCaretLeft.js')),
    IconCaretRight: lazy(() => import('./IconCaretRight.js')),
    IconCaretUp: lazy(() => import('./IconCaretUp.js')),
    IconCbd: lazy(() => import('./IconCbd.js')),
    IconCertificate: lazy(() => import('./IconCertificate.js')),
    IconChat: lazy(() => import('./IconChat.js')),
    IconChatbot: lazy(() => import('./IconChatbot.js')),
    IconCheck: lazy(() => import('./IconCheck.js')),
    IconCheckCircle: lazy(() => import('./IconCheckCircle.js')),
    IconChristmasTree: lazy(() => import('./IconChristmasTree.js')),
    IconClose: lazy(() => import('./IconClose.js')),
    IconCloseCircle: lazy(() => import('./IconCloseCircle.js')),
    IconCloseFilledCircle: lazy(() => import('./IconCloseFilledCircle.js')),
    IconContactLenses: lazy(() => import('./IconContactLenses.js')),
    IconCooling: lazy(() => import('./IconCooling.js')),
    IconCopy: lazy(() => import('./IconCopy.js')),
    IconCosmetics: lazy(() => import('./IconCosmetics.js')),
    IconCup: lazy(() => import('./IconCup.js')),
    IconDelivery: lazy(() => import('./IconDelivery.js')),
    IconDescription: lazy(() => import('./IconDescription.js')),
    IconDiabetes: lazy(() => import('./IconDiabetes.js')),
    IconDiscount: lazy(() => import('./IconDiscount.js')),
    IconDiscountBasic: lazy(() => import('./IconDiscountBasic.js')),
    IconDiscountCircle: lazy(() => import('./IconDiscountCircle.js')),
    IconDoctor: lazy(() => import('./IconDoctor.js')),
    IconDocument: lazy(() => import('./IconDocument.js')),
    IconDonation: lazy(() => import('./IconDonation.js')),
    IconDownload: lazy(() => import('./IconDownload.js')),
    IconEuro: lazy(() => import('./IconEuro.js')),
    IconEyeClose: lazy(() => import('./IconEyeClose.js')),
    IconEyeOpen: lazy(() => import('./IconEyeOpen.js')),
    IconFax: lazy(() => import('./IconFax.js')),
    IconFemale: lazy(() => import('./IconFemale.js')),
    IconFilter: lazy(() => import('./IconFilter.js')),
    IconFingerprint: lazy(() => import('./IconFingerprint.js')),
    IconFlag: lazy(() => import('./IconFlag.js')),
    IconFlashLightCameraOff: lazy(() => import('./IconFlashLightCameraOff.js')),
    IconFlashLightCameraOn: lazy(() => import('./IconFlashLightCameraOn.js')),
    IconHaemorrhoids: lazy(() => import('./IconHaemorrhoids.js')),
    IconHayFever: lazy(() => import('./IconHayFever.js')),
    IconHeadache: lazy(() => import('./IconHeadache.js')),
    IconHealth: lazy(() => import('./IconHealth.js')),
    IconHelp: lazy(() => import('./IconHelp.js')),
    IconHome: lazy(() => import('./IconHome.js')),
    IconHomeopathic: lazy(() => import('./IconHomeopathic.js')),
    IconHourglass: lazy(() => import('./IconHourglass.js')),
    IconImage: lazy(() => import('./IconImage.js')),
    IconInfo: lazy(() => import('./IconInfo.js')),
    IconItem: lazy(() => import('./IconItem.js')),
    IconLeaf: lazy(() => import('./IconLeaf.js')),
    IconLeaflet: lazy(() => import('./IconLeaflet.js')),
    IconLocation: lazy(() => import('./IconLocation.js')),
    IconLockClosed: lazy(() => import('./IconLockClosed.js')),
    IconLockOpen: lazy(() => import('./IconLockOpen.js')),
    IconLocker: lazy(() => import('./IconLocker.js')),
    IconLogin: lazy(() => import('./IconLogin.js')),
    IconLogout: lazy(() => import('./IconLogout.js')),
    IconMail: lazy(() => import('./IconMail.js')),
    IconMailActive: lazy(() => import('./IconMailActive.js')),
    IconManufacturer: lazy(() => import('./IconManufacturer.js')),
    IconMap: lazy(() => import('./IconMap.js')),
    IconMarketplace: lazy(() => import('./IconMarketplace.js')),
    IconMask: lazy(() => import('./IconMask.js')),
    IconMedicalAdviceCommunication: lazy(() => import('./IconMedicalAdviceCommunication.js')),
    IconMedicalChatbot: lazy(() => import('./IconMedicalChatbot.js')),
    IconMenu: lazy(() => import('./IconMenu.js')),
    IconMicrophone: lazy(() => import('./IconMicrophone.js')),
    IconMinus: lazy(() => import('./IconMinus.js')),
    IconMinusCircle: lazy(() => import('./IconMinusCircle.js')),
    IconMore: lazy(() => import('./IconMore.js')),
    IconMultiplierOverview: lazy(() => import('./IconMultiplierOverview.js')),
    IconNfc1: lazy(() => import('./IconNfc1.js')),
    IconNfc2: lazy(() => import('./IconNfc2.js')),
    IconNoSmoking: lazy(() => import('./IconNoSmoking.js')),
    IconNonPrescitption: lazy(() => import('./IconNonPrescitption.js')),
    IconNotifications: lazy(() => import('./IconNotifications.js')),
    IconNotificationsActive: lazy(() => import('./IconNotificationsActive.js')),
    IconNowAvailable: lazy(() => import('./IconNowAvailable.js')),
    IconNowUnavailable: lazy(() => import('./IconNowUnavailable.js')),
    IconOpenInLaunchExternal: lazy(() => import('./IconOpenInLaunchExternal.js')),
    IconOrderProcessing: lazy(() => import('./IconOrderProcessing.js')),
    IconOrthopedics: lazy(() => import('./IconOrthopedics.js')),
    IconPackage: lazy(() => import('./IconPackage.js')),
    IconPackageDamaged: lazy(() => import('./IconPackageDamaged.js')),
    IconPackageMissingProduct: lazy(() => import('./IconPackageMissingProduct.js')),
    IconPackageReceived: lazy(() => import('./IconPackageReceived.js')),
    IconPackageReturn: lazy(() => import('./IconPackageReturn.js')),
    IconPasskey: lazy(() => import('./IconPasskey.js')),
    IconPasteAndroid: lazy(() => import('./IconPasteAndroid.js')),
    IconPasteIOs: lazy(() => import('./IconPasteIOs.js')),
    IconPause: lazy(() => import('./IconPause.js')),
    IconPaymentMethod: lazy(() => import('./IconPaymentMethod.js')),
    IconPdf: lazy(() => import('./IconPdf.js')),
    IconPen: lazy(() => import('./IconPen.js')),
    IconPet: lazy(() => import('./IconPet.js')),
    IconPharmacy: lazy(() => import('./IconPharmacy.js')),
    IconPhone: lazy(() => import('./IconPhone.js')),
    IconPickUp: lazy(() => import('./IconPickUp.js')),
    IconPills: lazy(() => import('./IconPills.js')),
    IconPlantBased: lazy(() => import('./IconPlantBased.js')),
    IconPlayIconOnly: lazy(() => import('./IconPlayIconOnly.js')),
    IconPlayInACircle: lazy(() => import('./IconPlayInACircle.js')),
    IconPlus: lazy(() => import('./IconPlus.js')),
    IconPlusCircle: lazy(() => import('./IconPlusCircle.js')),
    IconPrescription: lazy(() => import('./IconPrescription.js')),
    IconPrescriptionMail: lazy(() => import('./IconPrescriptionMail.js')),
    IconPresentGiftCoupon: lazy(() => import('./IconPresentGiftCoupon.js')),
    IconPresentGiftCouponSide: lazy(() => import('./IconPresentGiftCouponSide.js')),
    IconPrinter: lazy(() => import('./IconPrinter.js')),
    IconProfileUserAvatar: lazy(() => import('./IconProfileUserAvatar.js')),
    IconProfileUserAvatarLoggedIn: lazy(() => import('./IconProfileUserAvatarLoggedIn.js')),
    IconPromotionOverview: lazy(() => import('./IconPromotionOverview.js')),
    IconProteinPowder: lazy(() => import('./IconProteinPowder.js')),
    IconReceipt: lazy(() => import('./IconReceipt.js')),
    IconReload: lazy(() => import('./IconReload.js')),
    IconReorder: lazy(() => import('./IconReorder.js')),
    IconSadFace: lazy(() => import('./IconSadFace.js')),
    IconSanitizer: lazy(() => import('./IconSanitizer.js')),
    IconSavings: lazy(() => import('./IconSavings.js')),
    IconScales: lazy(() => import('./IconScales.js')),
    IconScannerBarcode: lazy(() => import('./IconScannerBarcode.js')),
    IconScannerERx: lazy(() => import('./IconScannerERx.js')),
    IconSeal: lazy(() => import('./IconSeal.js')),
    IconSearch: lazy(() => import('./IconSearch.js')),
    IconSettings: lazy(() => import('./IconSettings.js')),
    IconShareIOs: lazy(() => import('./IconShareIOs.js')),
    IconShareWebAndroid: lazy(() => import('./IconShareWebAndroid.js')),
    IconShelterStayAtHome: lazy(() => import('./IconShelterStayAtHome.js')),
    IconShield: lazy(() => import('./IconShield.js')),
    IconShoppingCart: lazy(() => import('./IconShoppingCart.js')),
    IconShoppingCartAddToCart: lazy(() => import('./IconShoppingCartAddToCart.js')),
    IconShoppingCartFilled: lazy(() => import('./IconShoppingCartFilled.js')),
    IconShoppingCartWithCheckmark: lazy(() => import('./IconShoppingCartWithCheckmark.js')),
    IconSmiley: lazy(() => import('./IconSmiley.js')),
    IconSort: lazy(() => import('./IconSort.js')),
    IconSport: lazy(() => import('./IconSport.js')),
    IconSpray: lazy(() => import('./IconSpray.js')),
    IconStar: lazy(() => import('./IconStar.js')),
    IconStarFilled: lazy(() => import('./IconStarFilled.js')),
    IconStarHalf: lazy(() => import('./IconStarHalf.js')),
    IconSun: lazy(() => import('./IconSun.js')),
    IconSuperFastDelivery: lazy(() => import('./IconSuperFastDelivery.js')),
    IconSupport: lazy(() => import('./IconSupport.js')),
    IconSustainability: lazy(() => import('./IconSustainability.js')),
    IconSwapExchange: lazy(() => import('./IconSwapExchange.js')),
    IconSwissFranc: lazy(() => import('./IconSwissFranc.js')),
    IconTag: lazy(() => import('./IconTag.js')),
    IconThumbDown: lazy(() => import('./IconThumbDown.js')),
    IconThumbUp: lazy(() => import('./IconThumbUp.js')),
    IconTime: lazy(() => import('./IconTime.js')),
    IconTouch: lazy(() => import('./IconTouch.js')),
    IconTrashDelete: lazy(() => import('./IconTrashDelete.js')),
    IconUpload: lazy(() => import('./IconUpload.js')),
    IconVegan: lazy(() => import('./IconVegan.js')),
    IconVegetarian: lazy(() => import('./IconVegetarian.js')),
    IconVoucher: lazy(() => import('./IconVoucher.js')),
    IconWarning: lazy(() => import('./IconWarning.js')),
    IconWishlistAdd: lazy(() => import('./IconWishlistAdd.js')),
    IconWishlistAdded: lazy(() => import('./IconWishlistAdded.js')),
};
